import * as CONSTANTS from '../../constants';

/**
 * Countdown the timer.
 *
 * @param commit
 */
export const countdown = ({ commit }) => {
    commit(CONSTANTS.ALERT_COUNTDOWN_DECREMENT);
};

/**
 * Reset the countdown. Payload is the message and alert level object.
 * Payload example: {message: 'fetch.success', level: 'success'}
 *
 * @param commit
 * @param payload
 */
export const reset = ({ commit }, payload) => {
    commit(CONSTANTS.ALERT_COUNTDOWN_RESET, payload);
};


// WEBPACK FOOTER //
// ./src/store/modules/alert/actions.js